module.exports = __webpack_public_path__ + "img/american-credit-google-review-bruce-bowlin.5dd4a2a.webp";